import { useEffect, useState } from "react";
import { Box, Grid, Button } from "@mui/material";
import { t } from "react-i18nify";
import { FormProvider, useForm } from "react-hook-form";
import EditionPanelGlobal from "./EditionPanelGlobal";
import { ScreenLoading } from "../../Widgets/CustomLoadings";
import { fetchData, fetchNewEntityTreeView } from "../../../js/utils/backend";
import { useDispatch, useSelector } from "react-redux";
import { VCheckBox, VTextField } from "../../Widgets/Custom Inputs/CustomInputs";
import Axios from "axios";
import CopyToClipboard from 'react-copy-to-clipboard';
import { BasicButton } from "../../Widgets/Custom Inputs/Buttons";
import { toastr } from "react-redux-toastr";
import { updateTreeViewNodeExpand } from "../../../js/redux/actions/userPref";
import { authUpdateExternalProviderToken } from "../../../js/redux/actions/auth";

/** Page view where the user can see main data about accessible entities */
const UserPrefEditionPanel = ({ route = "User/userPrefs" }) => {
    const methods = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
    });
    const { reset, setValue } = methods;
    const dispatch = useDispatch();
    const token = useSelector(state => state.auth.Token);
    const userID = useSelector(state => state.auth.UserID);
    const isExternal = useSelector(state => state.auth.External);
    const externalProvidersToken = useSelector(state => state.auth.ExternalProvidersToken);
    const externalProvidersTokenExpiryDate = useSelector(state => state.auth.ExternalProvidersTokenExpiryDate);
    const [loading, setLoading] = useState(true);
    const [externalProviderToken, setExternalProviderToken] = useState(externalProvidersToken ? externalProvidersToken : '');
    const [externalProviderTokenExpiryDate, setExternalProviderTokenExpiryDate] = useState(externalProvidersTokenExpiryDate ? externalProvidersTokenExpiryDate : '');

    const treeViewNodeExpand = useSelector(
        state => state.userPref.TreeViewNodeExpand
    );

    const newTreeViewExpand = (tree, entityID) => {
        for(let i=0; i<tree.length; i++){
            for(let j=0; j<tree[i].Countries.length; j++){
                for(let k=0; k<tree[i].Countries[j].OTEntities.length; k++){
                    if(tree[i].Countries[j].OTEntities[k].Value === entityID){
                        const element1 = `${tree[i]?.BranchID}:${tree[i]?.Countries[j]?.OTEntities[k]?.Value}`;
                        const element2 = `${tree[i]?.BranchID}:${tree[i]?.Countries[j]?.CountryID}`;
                        const element3 = tree[i]?.BranchID;
                        return [element1, element2, element3];
                    }
                }
            }
        }
    }

    useEffect(() => {
        const url = "OTEntity/getSearchSubMenuEntities";
        const config = {
            headers: { Authorization: "Bearer " + token }
        };
        const handleFetch = async () => { await fetchNewEntityTreeView(token).then(result => {
            if(result.data){
                Axios.post(url, [], config).then(response => {
                    if(treeViewNodeExpand[0].includes(':')){
                        const OTEntityID = treeViewNodeExpand[0].split(":")[treeViewNodeExpand[0].split(":").length-1];
                        dispatch(updateTreeViewNodeExpand(newTreeViewExpand(response.data, OTEntityID)));
                    }
                    else{
                        dispatch(updateTreeViewNodeExpand(newTreeViewExpand(response.data, treeViewNodeExpand[0])));
                    }
                })
            }
        })}
        handleFetch();
        // eslint-disable-next-line
    }, []);
 
    useEffect(() => {
        const fetching = async () => {
            const response = await fetchData(route, token, "List");
            reset(response.data.Value);
            setLoading(false);
        };
        if (loading) {
            fetching();
        }
    }, [reset, route, token, loading]);

    useEffect(() => {
        setExternalProviderToken(externalProvidersToken ? externalProvidersToken : "");
        setExternalProviderTokenExpiryDate(externalProvidersTokenExpiryDate ? externalProvidersTokenExpiryDate : "");
        setValue("Explanatory Text", externalProvidersToken ? externalProvidersToken : "", {
            shouldDirty: false,
            shouldTouch: false,
            shouldValidate: false,
        });
    }, [externalProvidersToken, externalProvidersTokenExpiryDate, setValue]);

    const generateToken = () => {
        let config = {
            headers: { Authorization: "Bearer " + token },
        };
        const fetching = async () => {
            const response = await Axios.get('user/get-token-for-external-providers', config);
            setExternalProviderToken(response.data.Token);
            setExternalProviderTokenExpiryDate(response.data.TokenExpiryDate);
            dispatch(authUpdateExternalProviderToken(response.data.Token, response.data.TokenExpiryDate));

            setValue("Explanatory Text", response.data.Token, {
                shouldDirty: false,
                shouldTouch: false,
                shouldValidate: false,
            });

            await Axios.post(`user/update-provider-token-for-external-users`, {  ID: userID, Token: response.data.Token,TokenExpiryDate:response.data.TokenExpiryDate }, config);
        }
        fetching();
    }

    return loading ? (
        <ScreenLoading />
    ) : (
        <FormProvider {...methods}>
            <Grid m={1}>
                <Box sx={{ typography: "h3", p: 2, ml: 2, mb: 1 }}>
                    {t("grid.title.UserPref")}
                </Box>
                <Grid p={2} sx={{ pb:17 }}>
                    <EditionPanelGlobal
                        route={route}
                        ID={userID}
                        onSubmit={() => setLoading(true)}
                        afterSubmit={() => window.location.reload()}
                        back={false}
                    >
                        <>
                            <Grid item xs={12}>
                                <Box sx={{ typography:"subtitleMajor", p: 2 }}>
                                    {t("common.Preferences")}
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <VCheckBox
                                    label={t("field.EmailNotif")}
                                    fieldName={"RecieveEmail"}
                                />
                            </Grid>
                            {!isExternal &&
                                <Grid item xs={6} sx={{ mb: 5 }}>
                                    <VCheckBox
                                        label={t("field.ChangeEntityTreeView")}
                                        fieldName={"DisplayEntityTreeByBranchesAndCountries"}
                                    />
                                </Grid>
                            }
                        </>
                    </EditionPanelGlobal>
                        <Grid item xs={12}>
                            <Box sx={{ typography:"subtitleMajor", p: 2, mt: 5 }}>
                                {t("common.ApiToken")}
                            </Box>
                        </Grid>
                        <Box sx={{
                            typography: "body1", fontWeight: "bold", ml: 2, mb:2
                        }}>
                            {t("field.ExplanatoryText")}
                            {externalProviderTokenExpiryDate === ''
                                ? t("field.ExplanatoryTextEXT")
                                : new Date(externalProviderTokenExpiryDate).toLocaleDateString(navigator.language)
                                // :dateOnlyToString('2025/3/15')
                            }
                        </Box>
                    <Grid item xs={12}>
                        <VTextField
                            fieldName={"Explanatory Text"}
                            multiline
                            rows={4}
                            inputProps={{ readOnly: true }}
                            disabled
                            value={externalProviderToken}  
                        />
                        <div>
                            <CopyToClipboard text={externalProviderToken}
                            onCopy={() =>toastr.success(t('common.CopiedSuccessfully'))}>
                                <BasicButton size="small">{t("common.CopytoClipboard")}</BasicButton>
                            </CopyToClipboard>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            onClick={generateToken}
                            variant="contained"
                            type="submit"
                            size="small"
                            sx={{
                                ml: 1,
                            }}
                            disabled = {externalProviderToken !== ''}
                        >
                            {t("common.GenerateAToken")}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </FormProvider>
    );
};

export default UserPrefEditionPanel;
